import script from "./AppAdsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppAdsList.vue?vue&type=script&lang=ts&setup=true"

import "./AppAdsList.vue?vue&type=style&index=0&id=1cc924a3&lang=css"

const __exports__ = script;

export default __exports__